import { styled } from '@mui/system';
import theme from '../../../components/App/theme';
import { COLORS } from './colors';

export const GaugeCards = styled('div')(({ theme: { spacing } }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: spacing(2),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
}));

interface GaugeCardContainerProps {
  hasNextScore: boolean;
}
export const GaugeCardContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasNextScore',
})<GaugeCardContainerProps>(({ theme: { spacing }, hasNextScore }) => ({
  position: 'relative',
  width: '100%',
  height: hasNextScore ? '263px' : '238px',
  overflow: 'hidden',
  padding: `${spacing(3)} 0`,
  backgroundColor: COLORS.black[80],
  borderRadius: spacing(1.5),
}));

export const GaugeCardTitle = styled('div')({
  position: 'absolute',
  width: '100%',
  fontWeight: 500,
  fontSize: 16,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: COLORS.white[50],
  lineHeight: '22px',
  textAlign: 'center',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

export const GaugeCardChart = styled('div')({
  position: 'absolute',
  width: '100%',
  height: '300px',
});

export const GaugeCardScore = styled('div')({
  position: 'absolute',
  top: '139px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '60px',
  height: '35px',
  backgroundColor: COLORS.black[50],
  textAlign: 'center',
  fontSize: '27px',
  lineHeight: '35px',
  fontWeight: 700,
});

export const GaugeCardTotal = styled('div')({
  position: 'absolute',
  top: '194px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'auto',
  height: '20px',
  textAlign: 'center',
  fontSize: '20px',
  lineHeight: '1',
});

export const GaugeCardNextScore = styled('div')({
  position: 'absolute',
  top: '224px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '100%',
  height: '15px',
  textAlign: 'center',
  fontSize: '15px',
  lineHeight: '1',
  color: COLORS.white[50],
});
